import {
  ChangeDetectorRef,
  Component,
  NgModule,
  OnInit,
  ViewChild,
} from '@angular/core';
import { ActivatedRoute, RouterModule, Routes } from '@angular/router';
import { GearsApiService } from 'src/app/services/gearsapi.service';
import { CommonModule, Location } from '@angular/common';
import { ModalService } from 'src/app/modules/modalservice.service';
import { SitesService } from 'src/app/services/sites.service';
import { environment } from 'src/environments/environment';

import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer, Meta, Title } from '@angular/platform-browser';
import { SliderComponent, SliderModule } from '../../../slider/slider.component';
import { ImglistComponent } from '../../../imglist/imglist.component';
import { ModelcolourComponent } from '../../../modelcolour/modelcolour.component';
import {
  ReviewsComponent,
  ReviewsModule,
} from '../../../reviews/reviews.component';
import { EnquireComponent } from '../../../enquire/enquire.component';
import { TaskServiceService } from 'src/app/services/task-service.service';

@Pipe({
  name: 'safe',
})
export class SafePipe implements PipeTransform {
  constructor(private sanitizer: DomSanitizer) {}
  transform(url: any) {
    return this.sanitizer.bypassSecurityTrustResourceUrl(url);
  }
}
declare var Spin: any;
@Component({
  selector: 'app-detailsBase',
  templateUrl: './detailsBase.component.html',
  styleUrls: ['./detailsBase.component.less'],
})
export class DetailsBaseComponent implements OnInit {
  @ViewChild('spin', { static: false }) spin: any;
  hideColourName: boolean = false;
  hideFinance: any;
  currency: any;
  extraInfo: any;
  HideVehicleImage: any;
  constructor(
    private changeDetector: ChangeDetectorRef,
    private siteService: SitesService,
    private apiservice: GearsApiService,
    private route: ActivatedRoute,
    private location: Location,
    public modalService: ModalService,
    private title: Title,
    private meta: Meta,
    private taskservice: TaskServiceService
  ) {}
  Model: any = [];
  Specs: any[] = [];
  Images: any = [];
  modelId: string = '0';
  type: string = '0';
  modelname: string = '0';
  Dealerships: any;
  Dealer: any;
  imgaeindex: number = 0;
  imgloaded: boolean = false;
  specsOpen = false;
  galltype = 0;
  Ford: any;
  Accessories: any = [];
  currentSite: any;
  Stock: any = [];
  Loaded360: boolean = false;
  DataSource: any;
  updatedPrice: any;

  href(ref: string) {
    window.location.href = ref;
  }
  fav(id: string, type: string) {
    var favs: any[] = JSON.parse(localStorage.getItem('fav') || '[]');
    if (!favs.includes(type + '-' + id)) {
      favs.push(type + '-' + id);
    } else {
      const index = favs.indexOf(type + '-' + id);
      if (index > -1) {
        favs.splice(index, 1);
      }
    }
    localStorage.setItem('fav', JSON.stringify(favs));
  }
  isfav(v: any, type: string) {
    return JSON.parse(localStorage.getItem('fav') || '[]').includes(
      type + '-' + (v.VehicleStockID_PK || v.VehicleModelID_PK || v.VehicleID)
    );
  }
  stockenquire(vehicle: any) {
    var data = {
      ID:
        vehicle.SpecialID_PK ||
        vehicle.VehicleStockID_PK ||
        vehicle.VehicleModelID_PK ||
        vehicle.VehicleID,
      Name: vehicle.WebFriendlyName ? (vehicle.ModelYear + ' ' + vehicle.WebFriendlyName) 
          : vehicle.type == 'NewModel' ? vehicle.ModelDescription || vehicle.Caption 
          : vehicle.ModelDescription ? (vehicle.ModelYear + ' ' + vehicle.ModelDescription) : vehicle.Caption,
      Dealer: vehicle.GroupSpecial ? null : vehicle.DealershipID_FK,
      Price:
        vehicle.NewVehiclePrice || vehicle.Price || vehicle.RetailPriceIncl,
      Type:
        'newstock',
      Source: this.DataSource,
    };
    this.modalService.open('enquire', data);
  }
  stockfinance(price: number) {
    this.modalService.open('finance', price);
  }
  urlsan(url: any) {
    return url
      .replaceAll('+', '')
      .replaceAll('/', '')
      .replaceAll('\\', '')
      .replaceAll('(', '')
      .replaceAll(')', '')
      .replaceAll(' ', '_');
  }

  loadScripts() {
    if (!this.Loaded360) {
        this.Loaded360 = true;
        this.changeDetector.detectChanges();
      const dynamicScripts = [
        'https://static.instavid360.com/p/0.7.latest/spin360.lite.js',
      ];
      for (let i = 0; i < dynamicScripts.length; i++) {
        const node = document.createElement('script');
        node.src = dynamicScripts[i];
        node.setAttribute('data-portal', 'master');
        node.setAttribute('data-spin', this.Model.InstavidSpinID);
        this.spin.nativeElement.appendChild(node);
      }
    }  
  }

  VehicleMakeTypeExcludeVAT:any = [];
  VatExclusive(vehicleType:any, vehicleMakeID:any){
    return this.VehicleMakeTypeExcludeVAT.some((x:any)=> x.VehicleTypeName == vehicleType && x.VehicleMakeID == vehicleMakeID);
  }
  getVATStatus(){
    // if (this.Site.layoutFeatures.includes('vatexclusivelabel')){
      this.apiservice.get('SiteBrandVehicleTypes',{
        OrderBy:'Name.ASC',
        PageNumber:1,
        PageSize:9999,
        SiteID_FK:this.currentSite.SiteID_PK,
        Active:true,
        Deleted:false
      }).then((x:any)=>{
        let SBVT = x.body;
        SBVT = SBVT.filter((obj:any)=> obj.VatInclusive == false);
        let VehicleMakeType:any = [];
        const arrPost = []
        for (let i = 0; i<SBVT.length; i++) {
          VehicleMakeType.push(SBVT[i]);
          arrPost.push(this.apiservice.get('BrandVehicleMakes',
            {
              BrandID_FK:SBVT[i].BrandID_FK,
              Active:true,
              Deleted:false,
              PageNumber:1,
              PageSize:9999,
              OrderBy: ''
            }
          ));
        }
        Promise.all(arrPost).then((vals:any)=>{
          for (let i = 0; i<vals.length; i++) {
            VehicleMakeType[i].VehicleMakeID = vals[i].body[0].VehicleMakeID_FK;
          }
          this.VehicleMakeTypeExcludeVAT= VehicleMakeType;
        })
      });
    // }
  }

  image() {
    if (this.Model.Image) {
      return this.Model.Image.includes('http')
        ? this.Model.Image
        : environment.storageurl + this.Model.Image;
    } else {
      return this.Model.Images[0].includes('http')
        ? this.Model.Images[0]
        : environment.storageurl + this.Model.Images[0];
    }
  }

  updateMetaTags() {
    if (this.type == 'new') {
      this.meta.updateTag({
        name: 'keywords',
        content:
          'Bidvest, McCarthy, Vehicle, Used, Car, ' +
          this.Model.VehicleMake + ', ' +
          this.Model.VehicleSeries + ', ' +
          (this.Model.ModelYear || '') + ', ' +
          (this.Model.NewVehiclePrice != 0 ? this.currency + Math.round(this.Model.NewVehiclePrice).toLocaleString() : 'POA')
      });
      this.meta.updateTag({
        name: 'description',
        content:
          "New " + this.Model.ModelDescription + "for sale at a " +
          this.currentSite?.container?.Name + " dealership near you. From " +
          (this.Model.NewVehiclePrice != 0 ? this.currency + Math.round(this.Model.NewVehiclePrice).toLocaleString() : 'POA')
      });
      this.meta.updateTag({
        name: 'og:keywords',
        content:
          'Bidvest, McCarthy, Vehicle, Used, Car, ' +
          this.Model.VehicleMake + ', ' +
          this.Model.VehicleSeries + ', ' +
          (this.Model.ModelYear || '') + ', ' +
          (this.Model.NewVehiclePrice != 0 ? this.currency + Math.round(this.Model.NewVehiclePrice).toLocaleString() : 'POA')
      });
      this.meta.updateTag({
        name: 'og:description',
        content:
          "New " + this.Model.ModelDescription + "for sale at a " +
          this.currentSite?.container?.Name + " dealership near you. From " +
          (this.Model.NewVehiclePrice != 0 ? this.currency + Math.round(this.Model.NewVehiclePrice).toLocaleString() : 'POA')
      });
      this.meta.updateTag({
        name: 'og:title',
        content:
          "New " + this.Model.ModelDescription + " | " +
          this.currentSite?.container?.Name,
      });
      this.meta.updateTag({ name: 'og:site_name', content: this.currentSite.Name});
      this.meta.updateTag({ name: 'image', content: this.image()});
      this.meta.updateTag({ name: 'og:image', content: this.image()});
      this.meta.updateTag({ name: 'twitter:image', content: this.image()});
      this.meta.updateTag({ name: 'og:url', content: window.location.href});
      this.meta.updateTag({
        name: 'twitter:description',
        content:
          (this.Model.ModelYear || '') + ' ' +
          this.Model.ModelDescription + ' ' +
          (this.Model.NewVehiclePrice != 0 ? this.currency + Math.round(this.Model.NewVehiclePrice).toLocaleString() : 'POA')
      });
      this.meta.updateTag({
        name: 'twitter:title',
        content:
          (this.Model.ModelYear || '') + ' ' +
          this.Model.ModelDescription + ' ' +
          (this.Model.NewVehiclePrice != 0 ? this.currency + Math.round(this.Model.NewVehiclePrice).toLocaleString() : 'POA')
      });
    } else if (this.type == 'stock') {
      this.meta.updateTag({
        name: 'keywords',
        content:
          'Bidvest, McCarthy, Vehicle, Used, Car, ' + this.Model.VehicleMake + ', ' +
          this.Model.VehicleSeries + ', ' + (this.Model.ModelYear || '') + ', ' +
          (this.Model.RetailPriceIncl != 0 ? this.currency + Math.round(this.Model.RetailPriceIncl).toLocaleString() : 'POA')
      });
      this.meta.updateTag({
        name: 'description',
        content:
          (this.Model.VehicleStockType || '') + ' ' +
          (this.Model.ModelYear || '') + ' ' +
          this.Model.WebFriendlyName + ' for sale at ' +
          this.Model.DealershipName + '. From ' +
          (this.Model.RetailPriceIncl != 0 ? this.currency + Math.round(this.Model.RetailPriceIncl).toLocaleString() : 'POA') + '. Mileage: ' +
          (this.Model.OdoMeterReading.toLocaleString() || 'Unknown') + 'kms',
      });
      this.meta.updateTag({
        name: 'og:keywords',
        content:
          'Bidvest, McCarthy, Vehicle, Used, Car, ' + this.Model.VehicleMake + ', ' +
          this.Model.VehicleSeries + ', ' +
          (this.Model.ModelYear || '') + ', ' +
          this.currency + Math.round(this.Model.RetailPriceIncl),
      });
      this.meta.updateTag({
        name: 'og:description',
        content:
          (this.Model.VehicleStockType || '') + ' ' +
          (this.Model.ModelYear || '') + ' ' +
          this.Model.WebFriendlyName + ' for sale at ' +
          this.Model.DealershipName + '. From ' +
          (this.Model.RetailPriceIncl != 0 ? this.currency + Math.round(this.Model.RetailPriceIncl).toLocaleString() : 'POA') + '. Mileage: ' +
          (this.Model.OdoMeterReading.toLocaleString() || 'Unknown') + 'kms',
      });
      this.meta.updateTag({
        name: 'og:title',
        content:
        (this.Model.VehicleStockType || '') + ' ' +
        (this.Model.ModelYear || '') + ' ' +
        this.Model.WebFriendlyName + ' | ' +
        this.Model.DealershipName,
      });
      this.meta.updateTag({ name: 'og:site_name', content: this.currentSite.Name});
      this.meta.updateTag({ name: 'image', content: this.image()});
      this.meta.updateTag({ name: 'og:image', content: this.image()});
      this.meta.updateTag({ name: 'twitter:image', content: this.image()});
      this.meta.updateTag({ name: 'og:url', content: window.location.href});
      this.meta.updateTag({
        name: 'twitter:description',
        content:
          (this.Model.ModelYear || '') + ' ' +
          this.Model.WebFriendlyName + ' ' +
          (this.Model.RetailPriceIncl != 0 ? this.currency + Math.round(this.Model.RetailPriceIncl).toLocaleString() : 'POA')
      });
      this.meta.updateTag({
        name: 'twitter:title',
        content:
          (this.Model.ModelYear || '') + ' ' +
          this.Model.WebFriendlyName + ' ' +
          (this.Model.RetailPriceIncl != 0 ? this.currency + Math.round(this.Model.RetailPriceIncl).toLocaleString() : 'POA')
      });
    } else {
      this.meta.updateTag({
        name: 'keywords',
        content: 'Bidvest, McCarthy, Vehicle, Used, Car, ' + this.Model.VehicleMakeName + ', ' + this.Model.Caption,
      });
      this.meta.updateTag({
        name: 'og:keywords',
        content: 'Bidvest, McCarthy, Vehicle, Used, Car, ' + this.Model.VehicleMakeName + ', ' + this.Model.Caption,
      });
      this.meta.updateTag({ name: 'description', content: this.Model.Caption});
      this.meta.updateTag({ name: 'og:description', content: this.Model.Caption});
      this.meta.updateTag({ name: 'og:title', content: this.Model.Caption});
      this.meta.updateTag({ name: 'og:site_name', content: this.currentSite.Name});
      this.meta.updateTag({ name: 'image', content: this.image() });
      this.meta.updateTag({ name: 'og:image', content: this.image() });
      this.meta.updateTag({ name: 'twitter:description', content: this.Model.Caption});
      this.meta.updateTag({ name: 'twitter:title', content: this.Model.Caption});
      this.meta.updateTag({ name: 'twitter:image', content: this.image()});
      this.meta.updateTag({ name: 'og:url', content: window.location.href});
    }
  }

  ngOnInit(): void {
    this.modelId = this.route.snapshot.paramMap.get('id')!;
    this.type = this.route.snapshot.paramMap.get('type')!;
    this.modelname = this.route.snapshot.paramMap.get('name')!;
    if (this.type == 'new') {
      this.apiservice
        .getSingle('VehicleModels', this.modelId, {})
        .then((x: any) => {
          if (x.body.Active) {
            this.Model = x.body;
            this.apiservice
              .get('VehicleModelSpecs', {
                VehicleModelID_FK: this.Model.VehicleModelID_PK,
              })
              .then((specs: any) => {
                this.Specs = specs.body;
              });
             
            this.siteService.get().then((site: any) => {
              this.currentSite = site;
              this.currency = this.currentSite.CurrencySymbol;
              this.getVATStatus();
              this.hideColourName = this.currentSite.layoutFeatures.some((feature: any) => feature.toUpperCase() == 'HIDECOLOURNAME');
              this.extraInfo = this.currentSite.layoutFeatures.some((feature: any) => feature.toUpperCase() == 'EXTRAVEHICLEINFORMATION');

              this.hideFinance = this.currentSite.layoutGlobal?.some((global: any) => global.PageLayoutTypeName.toUpperCase() == 'HIDEFINANCE');

              this.title.setTitle("New " + this.Model.ModelDescription + " | " + this.currentSite?.container?.Name);

              this.HideVehicleImage = this.currentSite.layoutFeatures.some((feature: any) => feature.toUpperCase() == 'HIDESWATCHVEHICLEIMAGE');
              
              this.apiservice
              .get('VehicleStock', {
                VehicleStockType: 'NEW',
                PageSize: 5,
                PageNumber: 1,
                OrderBy: '',
                VehicleModelID_FK: this.Model.VehicleModelID_PK,
                SiteID_FK:site.SiteID_PK
              })
              .then((specs: any) => {
                this.Stock = specs.body;

                this.Ford = this.currentSite.layoutGlobal.some((global: any) => global.PageLayoutTypeName.toUpperCase() == 'CREDIT');
              });
              this.apiservice
                .get('Dealerships', { SiteID_FK: site.SiteID_PK })
                .then((dealers: any) => {
                  this.Dealerships = dealers.body;
                  this.DataSource = dealers.body[0].DataSourceID_FK;
                  this.Model.NewVehiclePrice = this.DataSource == 1 ? this.Model.NewVehiclePrice : this.Model.NamibiaNewVehiclePrice;
                });
              this.loadVehicleSchema();
              this.updateMetaTags();
            });
            this.Images = this.Model.Images;
            this.imgloaded = true;

            this.gtag('n');
          } else {
            window.location.href = '404';
          }
        });
    }
    if (this.type == 'stock') {
      this.siteService.get().then((site: any) => {
        this.currentSite = site;
        this.currency = this.currentSite.CurrencySymbol;
        this.apiservice
          .getSingle('VehicleStock', this.modelId, {})
          .then((x: any) => {

            if (x.body.Active) {
              this.Model = x.body;
              if (this.Model.VehicleStockType.toLowerCase() ==  "new") {
                this.taskservice.navUpdate("new");
              }
              else if (this.Model.VehicleStockType.toLowerCase() ==  "demo") {
                this.taskservice.navUpdate("demo");
              }
              else {
                this.taskservice.navUpdate("used");
              }
              this.title.setTitle(this.Model.VehicleStockType.toUpperCase() + " " + this.Model.ModelYear + " " + this.Model.WebFriendlyName + " | " + this.currentSite.container.Name);
              this.sortAcc();
              this.Images = this.Model.Images;
              this.imgloaded = true;

              this.gtag('u');
              this.loadVehicleSchema();
              if (this.Model.DealershipID_FK != null) {
                this.apiservice
                  .getSingle('Dealerships', this.Model.DealershipID_FK, {})

                  .then((x: any) => {

                    this.Dealer = x.body;
                    this.DataSource = x.body.DataSourceID_FK;
                  });
              }

              this.updateMetaTags();
            } else {
              window.location.href = '404';
            }
          });
      });
    }
    if (this.type == 'special') {
      this.apiservice
        .getSingle('Specials', this.modelId, {})

        .then((x: any) => {
          if (x.body.Active) {
            this.Model = x.body;

            this.title.setTitle(this.Model.Caption);
            this.Model.Description = this.Model.Description?.replaceAll(
              'Terms and Conditions apply',
              ''
            );
            var tempDate = new Date(this.Model.DateEnd);
            this.Model.DateEnd = tempDate.getDate() +' '+ tempDate.toLocaleString('en-GB', { month: 'short' })
             +' '+ tempDate.getFullYear();
            this.Images.push(this.Model.Image);
            this.imgloaded = true;
            
            this.siteService.get().then((site: any) => {
              this.currentSite = site;
              if(site.dealerSite){
                this.Dealerships = [];
                this.Dealer = site.dealership;
              }
              else{
              this.apiservice.get('SiteSpecials', {
                PageNumber: 1,
                PageSize: 9999,
                OrderBy: 'Order.ASC',
                Deleted: 0,
                Active: 1,
                SpecialID_FK: this.modelId,
                //DateEnd: moment().startOf('day').add(2, 'hours').format('YYYY-MM-DD'),
                //SiteID_FK: site.SiteID_PK
              }).then((x: any) => {
                var SiteSpecialsList = x.body;

                this.Dealerships = [];
  
                SiteSpecialsList.forEach((item: any) => {
                  if (item?.DealershipID_FK !== null) {
                    if (!this.Dealerships.includes(item?.DealershipID_FK)) {
                      this.Dealerships.push(item.DealershipID_FK);
                    }
                  }
                  else{
                    this.Dealerships.push(-1);
                    this.Dealerships.push(-1);
                  }
                });

                if(this.Dealerships.length == 1){
                  this.apiservice.getSingle("Dealerships", this.Dealerships[0]).then((x: any) => {this.Dealer = x.body});
                }
                this.updateMetaTags();
              });}
            });
          } else {
            window.location.href = '404';
          }
        });
    }
    if (this.type == 'promo') {
      this.siteService.get().then((site: any) => {
        this.apiservice
          .get('promos', {
            Active: 1,
            Deleted: 0,
            OrderBy: '',
            PageNumber: 1,
            PageSize: 1,
            SiteID_FK: site.SiteID_PK,
            URL: this.modelId,
          })
          .then((y: any) => {
            if (y.body.length > 0) {
              this.apiservice
                .getSingle('Specials', y.body[0].SpecialID_FK, {})

                .then((x: any) => {

                  if (x.body.Active) {
                    this.Model = x.body;
                    this.Model.promo = y.body[0];
                    if (this.Model.promo?.ImageFilenameXS)this.Model.promo.ImageFilenameXS = environment.storageurl + this.Model.promo?.ImageFilenameXS;
                    if (this.Model.promo?.ImageFilenameSM)this.Model.promo.ImageFilenameSM = environment.storageurl + this.Model.promo?.ImageFilenameSM;
                    if (this.Model.promo?.ImageFilenameMD)this.Model.promo.ImageFilenameMD = environment.storageurl + this.Model.promo?.ImageFilenameMD;
                    if (this.Model.promo?.ImageFilenameLG)this.Model.promo.ImageFilenameLG = environment.storageurl + this.Model.promo?.ImageFilenameLG;
                    this.title.setTitle(this.Model.Caption);
                    this.Model.Description = this.Model.Description?.replaceAll(
                      'Terms and Conditions apply',
                      ''
                    );
                    this.Images.push(this.Model.Image);
                    this.imgloaded = true;
                    if (this.Model.GroupSpecial != true) {
                      this.apiservice
                        .getSingle(
                          'Dealerships',
                          this.Model.DealershipID_FK,
                          {}
                        )
                        .then((x: any) => {

                          this.Dealer = x.body;
                          this.DataSource = x.body.DataSourceID_FK;
                        });
                    }
                  } else {
                    window.location.href = '404';
                  }
                });

            }
          });
      });
    }
  }

  sortAcc() {
    if (this.Model.VehicleStockAccessoriesList) {
      var i = 0;
      this.Accessories =
        //var vehicleAccessories =
        this.Model.VehicleStockAccessoriesList.split(',');
      /*vehicleAccessories.sort();
      while (vehicleAccessories.length > 0) {
        this.Accessories.push([
          vehicleAccessories.shift(),
          vehicleAccessories.shift(),
        ]);
        i++;
      }*/
    }
  }

  gtag(type: any) {
    let gaScript = document.createElement('script');
    gaScript.innerText =
      "gtag('event','view_item', {'value': " +
      (this.Model.RetailPriceIncl || this.Model.NewVehiclePrice) +
      ",'items': [{'id': " +
      type +
      (this.Model.CACStockID || this.Model.CACID) +
      ",'google_business_vertical': 'retail'}]});";

    document.head.appendChild(gaScript);
  }

  monthlyPayment(price: any) {
    var vp = parseInt(price), //vehicle price incl vat
      // deposit as percentage. ie 10% will be passed through as 0.1
      dpamt = (vp * environment.FinanceDeposit) / 100, //deposit amount
      tm = environment.FinanceMonths, //terms month
      i = environment.FinanceInterest / 100, //interest rate
      loan = 0,
      MonPmt = 0,
      balloonAmount = (environment.FinanceBalloon / 100) * vp;
    loan = vp + environment.initfee - dpamt; //additional amounts are normally what mccarthy add on (once off fee R1140 and R57 per month)
    i /= 12;

    MonPmt = Math.ceil(
      (loan * Math.pow(1 + i, tm)) / ((Math.pow(1 + i, tm) - 1) / i) -
        balloonAmount / ((Math.pow(1 + i, tm) - 1) / i)
    );

    return MonPmt + environment.adminfee;
  }
  num(inp: string) {
    var it = inp;
    return it.split(' ').join(',');
  }
  enquire() {
    var data = {
      ID:
        this.Model.SpecialID_PK ||
        this.Model.VehicleStockID_PK ||
        this.Model.VehicleModelID_PK ||
        this.Model.VehicleID,
        Name: this.Model.WebFriendlyName ? (this.Model.ModelYear + ' ' + this.Model.WebFriendlyName) : this.Model.ModelDescription || this.Model.Caption,
      Dealer: this.Model.GroupSpecial ? null : this.Model.DealershipID_FK,
      Price:
        this.Model.NewVehiclePrice ||
        this.Model.Price ||
        this.Model.RetailPriceIncl,
      Type:
        this.Model.VehicleStockType ? 
        this.Model.VehicleStockType == 'New'? 'newstock':this.Model.VehicleStockType == 'Pre-Owned' || this.Model.VehicleStockType == 'Demo' ? 
                'used' 
                : this.Model.VehicleModelID_PK ?  'new' : this.Model.VehicleStockType.toLowerCase()
          : this.type == 'special' ? 'specials' : this.type,
      Source: this.DataSource,
    };
    this.modalService.open('enquire', data);
  }

  finance() {
    this.modalService.open(
      'finance',
      this.Model.RetailPriceIncl || this.Model.NewVehiclePrice, this.currency
    );
  }

  compare() {
    window.location.href =
      '/compare?type=' +
      (this.Model.VehicleStockType == 'Pre-Owned'
        ? 'used'
        : (this.Model.VehicleStockType || 'new').toLowerCase()) +
      '&vehicle1=' +
      this.modelId;
  }

  back(): void {
    this.location.back();
  }

  spec(name: string) {
    var find = this.Specs.find((x: any) => x.Name == name);
    if (find) {
      return find.Value;
    } else {
      return '-';
    }
  }

  specNam(name: string) {
    var find = this.Specs.find((x: any) => x.Name == name);
    if (find && find.NamibiaValue != null) {
      return find.NamibiaValue;
    } else {
      return '-';
    }
  }

  loadVehicleSchema() {
    var script   = document.createElement("script");
    script.type  = "application/ld+json";
    script.text  = `
    {
      "@context": "https://schema.org",
      "@type": "Vehicle",
      "name": "${this.Model.ModelDescription}",
      "brand": "${this.Model.VehicleMake}",
      "model": "${this.Model.VehicleSeries}",
      "vehicleModelDate": "${this.Model.ModelYear}",
      "vehicleTransmission": "${this.Model.VehicleTransmission}",
      "fuelType": "${this.Model?.VehicleFuelType || this.Model?.FuelType}",
      "bodyType": "${this.Model?.VehicleBodyType || this.Model?.VehicleType}",
      "offers": {
      "@type": "Offer",
      "price": "${(this.Model?.RetailPriceIncl || this.Model?.NewVehiclePrice) ? (Math.round(this.Model?.RetailPriceIncl) || this.Model?.NewVehiclePrice) : 'POA'}",
      "priceCurrency": "${this.currentSite.CurrencyCode}",
      "availability": "https://schema.org/InStock",
      "url": "${window.location.href}"
    }`;
    document.head.appendChild(script);
  }
}

const routes: Routes = [
  {
    path: '',
    component: DetailsBaseComponent,
    data: { Module: 'Buy', Title: 'Buy' },
  },
];

@NgModule({
  declarations: [
    DetailsBaseComponent,
    ImglistComponent,
    ModelcolourComponent,
    SafePipe
  ],
  imports: [
    CommonModule,
    SliderModule,
    ReviewsModule,
    EnquireComponent
  ],
  exports: [
    DetailsBaseComponent
  ]
})
export class DetailsBaseModule {}
